<template>
  <div class="container is-fluid" ref="container">
    <section class="section">
      <div class="is-flex is-align-items-center has-gap-5">
        <div class="is-flex is-align-items-center">
          <span
            v-if="customerLimit.firstName || customerLimit.lastName"
            class="is-size-4 has-text-weight-bold"
          >
            <template v-if="lastNameFirst">
              {{ customerLimit.lastName }} {{ customerLimit.firstName }}
            </template>
            <template v-else>
              {{ customerLimit.firstName }} {{ customerLimit.lastName }}
            </template>
          </span>
          <span v-else class="is-size-4 has-text-weight-bold">
            {{ $t("mp:customer_limit.page.title", { id: limitId }) }}
          </span>

          <span
            v-if="customerLimit.limitStatus"
            class="status-badge ml-4 status-badge-blue"
          >
            <span class="has-text-white">
              {{
                $t(
                  `mp:customer_limit.limit_status.${customerLimit.limitStatus.toLowerCase()}`
                )
              }}
            </span>
          </span>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="entity-details-card">
            <p class="is-size-5 has-text-weight-bold">
              {{ $t("mp:customer_limit.base_data.title") }}
            </p>
            <div
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 12px;
              "
            >
              <div v-if="customerLimit.currentLimit">
                <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                  {{ $t("mp:customer_limit.data_labels.current_limit") }}
                </p>
                <span class="has-text-weight-medium">
                  {{
                    formatMoney(
                      customerLimit.currencyIso,
                      customerLimit.currentLimit
                    )
                  }}
                </span>
              </div>
              <div>
                <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                  {{ $t("mp:customer_limit.data_labels.created") }}
                </p>
                <span class="has-text-weight-medium">
                  {{ formatDateTime(customerLimit.created) }}
                </span>
              </div>
              <div v-if="customerLimit.expirationDate">
                <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                  {{ $t("mp:customer_limit.data_labels.expiration_date") }}
                </p>
                <span class="has-text-weight-medium">
                  {{ formatDateTime(customerLimit.expirationDate) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-one-third">
          <div class="entity-details-card">
            <p class="is-size-5 has-text-weight-bold">
              {{ $t("mp:customer_limit.customer_data.title") }}
            </p>
            <div v-if="customerLimit.firstName || customerLimit.lastName">
              <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                {{ $t("mp:customer_limit.data_labels.name") }}
              </p>
              <span class="has-text-weight-medium">
                <template v-if="lastNameFirst">
                  {{ customerLimit.lastName }} {{ customerLimit.firstName }}
                </template>
                <template v-else>
                  {{ customerLimit.firstName }} {{ customerLimit.lastName }}
                </template>
              </span>
            </div>
            <div v-if="customerLimit.phone">
              <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                {{ $t("mp:customer_limit.data_labels.phone") }}
              </p>
              <span class="has-text-weight-medium">
                {{ formatPhone(customerLimit.phone) }}
              </span>
            </div>
            <div v-if="customerLimit.email">
              <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                {{ $t("mp:customer_limit.data_labels.email") }}
              </p>
              <span class="has-text-weight-medium">
                {{ customerLimit.email }}
              </span>
            </div>
            <div v-if="customerLimit.dateOfBirth">
              <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
                {{ $t("mp:customer_limit.data_labels.date_of_birth") }}
              </p>
              <span class="has-text-weight-medium">
                {{ formatDate(customerLimit.dateOfBirth) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section v-if="customerLimit.dynamicData" class="section">
      <h3>
        {{ $t("mp:customer_limit.dynamic_data.title") }}
      </h3>

      <div
        style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px"
      >
        <div
          v-for="(item, key) in JSON.parse(customerLimit.dynamicData)"
          :key="key"
        >
          <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
            {{ key }}
          </p>
          <span class="has-text-weight-medium">
            {{ item }}
          </span>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { localizedFormatter, applyCustomStringMask } from "@/utils/util";

export default {
  name: "BnplApplication",
  title: "pp:page.bnpl_application.title",
  components: {},
  props: {
    limitId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      customerLimit: "customerLimit/get",
      locale: "i18n/locale",
      lastNameFirst: "i18n/lastNameFirst",
      phoneMask: "i18n/phoneMask",
    }),
  },
  async created() {
    this.fetchOne(this.limitId);
  },
  methods: {
    ...mapActions({
      fetchOne: "customerLimit/fetchOne",
    }),
    formatDate(date) {
      return localizedFormatter(this.locale).date(date);
    },
    formatDateTime(date) {
      return localizedFormatter(this.locale).dateTime(date);
    },
    formatMoney(currency, amount) {
      return localizedFormatter(this.locale).money(currency, amount);
    },
    formatPhone(phone) {
      return applyCustomStringMask(this.phoneMask, phone);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.entity-details-card {
  padding: 1.5rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tile-empty {
  background: $grey-border;
  border-radius: 8px;
}

.has-text-danger:focus,
.has-text-danger:hover {
  color: white !important;
}

.has-text-danger:focus[disabled],
.has-text-danger:hover[disabled] {
  color: #f14668 !important;
}

.tile {
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
}
</style>
